module.exports = __webpack_public_path__ + "img/index-1.00f5d114.jpg";